


import Weather from "./Weather";

function App() {
  return (
    <div className="App">
     < Weather city="Liverpool"/>
    </div>
  );
}

export default App;
